<template>
  <svg
    class="ink-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="name === 'instagram'">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r=".5" fill="currentColor" />
    </template>
    <path v-else :d="paths[name] || paths.spark" />
  </svg>
</template>
<script setup>
defineProps({ name: { type: String, default: 'spark' } });
const paths = {
  arrow: 'M4 12h16M14 6l6 6-6 6',
  diagonal: 'M5 19 19 5M5 5h14v14',
  down: 'M12 4v16M6 14l6 6 6-6',
  up: 'M12 20V4M6 10l6-6 6 6',
  back: 'M20 12H4M10 6l-6 6 6 6',
  close: 'm6 6 12 12M6 18 18 6',
  menu: 'M4 8h16M4 16h16',
  check: 'm5 12 4 4L19 6',
  plus: 'M12 5v14M5 12h14',
  upload: 'M12 16V3M7 8l5-5 5 5M4 15v6h16v-6',
  trash: 'M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7',
  refresh: 'M20 8a8 8 0 1 0 0 8M20 3v5h-5',
  lock: 'M7 10V7a5 5 0 0 1 10 0v3M5 10h14v11H5ZM12 14v3',
  logout: 'M9 3H4v18h5M10 12h11M16 7l5 5-5 5',
  spark: 'M12 2c0 6-4 10-10 10 6 0 10 4 10 10 0-6 4-10 10-10-6 0-10-4-10-10Z',
  pin: 'M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  home: 'm3 10 9-7 9 7M5 9v12h14V9M9 21v-7h6v7',
  art: 'M3 4h18v16H3ZM3 16l6-6 5 5 3-3 4 4M17 8h.01',
  mail: 'M3 5h18v14H3ZM3 5l9 8 9-8',
  heart:
    'M20.8 4.6a5.5 5.5 0 0 0-7.8 0l-1 1-1-1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z',
};
</script>
